import Audiences from '@/modules/audiences/pages/Audiences'
import UserLists from '@/modules/audiences/pages/UserLists'
import UserListItems from '@/modules/audiences/pages/UserListItems'
import OptimoveLists from '@/modules/audiences/pages/OptimoveLists'
import OptimoveListItems from '@/modules/audiences/pages/OptimoveListItems'
import SuppressionLists from '@/modules/audiences/pages/SuppressionLists'
import SuppressionListItems from '@/modules/audiences/pages/SuppressionListItems'
import SegmentList from '@/modules/audiences/pages/SegmentList'
import SharedSegmentList from '@/modules/audiences/pages/SharedSegmentList'
import SegmentPage from '@/modules/audiences/pages/SegmentPage'
import SegmentPageUpdate from '@/modules/audiences/pages/SegmentPageUpdate'
import SegmentPageCreate from '@/modules/audiences/pages/SegmentPageCreate'
import SegmentPageCopy from '@/modules/audiences/pages/SegmentPageCopy'
import SegmentTabEvaluations from '@/modules/audiences/pages/SegmentTabEvaluations'
import SegmentTabOverview from '@/modules/audiences/pages/SegmentTabOverview'
import SegmentTabSharing from '@/modules/audiences/pages/SegmentTabSharing'
import SharedSegmentPage from '@/modules/audiences/pages/SharedSegmentPage'
import SharedSegmentTabEvaluations from '@/modules/audiences/pages/SharedSegmentTabEvaluations'
import SportradarLists from '@/modules/audiences/pages/SportradarLists'
import SportradarListItems from '@/modules/audiences/pages/SportradarListItems'
import RollingSegmentList from '@/modules/audiences/pages/RollingSegmentList'
import RollingSegmentTabOverview from '@/modules/audiences/pages/RollingSegmentTabOverview'
import RollingSegmentPage from '@/modules/audiences/pages/RollingSegmentPage'
import RollingSegmentPageCreate from '@/modules/audiences/pages/RollingSegmentPageCreate'
import RollingSegmentPageUpdate from '@/modules/audiences/pages/RollingSegmentPageUpdate'
import RollingSegmentTabEvaluations from '@/modules/audiences/pages/RollingSegmentTabEvaluations'
import RollingSegmentPageCopy from '@/modules/audiences/pages/RollingSegmentPageCopy'
import RollingSegmentTabDestinations from '@/modules/audiences/pages/RollingSegmentTabDestinations'

export default [
  {
    name: 'Audiences',
    path: '/audiences',
    component: Audiences,
    meta: {
      auth: ['Segment::Read'],
      title: 'Audiences_Title'
    },
    children: [
      {
        name: 'AudienceSegmentList',
        path: 'segments',
        component: SegmentList,
        meta: {
          auth: ['Segment::Read']
        }
      },
      {
        name: 'AudienceRollingSegmentList',
        path: 'rolling-segments',
        component: RollingSegmentList,
        meta: {
          auth: ['viewProjectItem']
        }
      },
      {
        name: 'AudienceUserList',
        path: 'user-lists',
        component: UserLists,
        project: true,
        meta: {
          auth: ['viewProjectItem']
        }
      },
      {
        name: 'AudienceOptimoveList',
        path: 'optimove-lists',
        component: OptimoveLists,
        project: true,
        meta: {
          auth: ['viewProjectItem']
        }
      },
      {
        name: 'AudienceSportradarList',
        path: 'sportradar-lists',
        component: SportradarLists,
        project: true,
        meta: {
          auth: ['viewProjectItem']
        }
      },
      {
        name: 'AudienceSuppressionList',
        path: 'suppression-lists',
        component: SuppressionLists,
        project: true,
        meta: {
          auth: ['viewProjectItem']
        }
      },
      {
        name: 'AudienceSegmentSharedList',
        path: 'shared-segments',
        component: SharedSegmentList,
        meta: {
          auth: ['viewProjectItem']
        }
      }
    ]
  },
  {
    name: 'AudienceUserListItems',
    path: '/audiences/user-list/items',
    component: UserListItems,
    project: true,
    meta: {
      auth: ['viewProjectItem']
    }
  },
  {
    name: 'AudienceOptimoveListItems',
    path: '/audiences/optimove-list/items',
    component: OptimoveListItems,
    project: true,
    meta: {
      auth: ['viewProjectItem']
    }
  },
  {
    name: 'AudienceSportradarListItems',
    path: '/audiences/sportradar-list/items',
    component: SportradarListItems,
    project: true,
    meta: {
      auth: ['viewProjectItem']
    }
  },
  {
    name: 'AudienceSuppressionListItems',
    path: '/audiences/suppression-list/items',
    component: SuppressionListItems,
    project: true,
    meta: {
      auth: ['viewProjectItem']
    }
  },
  {
    name: 'AudienceSegment',
    path: '/audiences/segment/overview',
    component: SegmentPage,
    meta: {
      auth: ['Segment::Read'],
      title: 'Audiences_Title'
    },
    children: [
      {
        name: 'AudienceSegmentOverview',
        path: '/audiences/segment/overview',
        component: SegmentTabOverview,
        meta: {
          auth: ['Segment::Read']
        }
      },
      {
        name: 'AudienceSegmentEvaluations',
        path: '/audiences/segment/evaluations',
        component: SegmentTabEvaluations,
        project: true,
        meta: {
          auth: ['Segment::Read']
        }
      },
      {
        name: 'AudienceSegmentSharing',
        path: '/audiences/segment/sharing',
        component: SegmentTabSharing,
        project: true,
        meta: {
          auth: ['manageProjectTechnical']
        }
      }
    ]
  },
  {
    name: 'AudienceRollingSegment',
    path: '/audiences/rolling-segment/overview',
    component: RollingSegmentPage,
    meta: {
      auth: ['viewProjectItem'],
      title: 'Audiences_Title'
    },
    children: [
      {
        name: 'AudienceRollingSegmentOverview',
        path: '/audiences/rolling-segment/overview',
        component: RollingSegmentTabOverview,
        meta: {
          auth: ['viewProjectItem']
        }
      },
      {
        name: 'AudienceRollingSegmentEvaluations',
        path: '/audiences/rolling-segment/evaluations',
        component: RollingSegmentTabEvaluations,
        project: true,
        meta: {
          auth: ['viewProjectItem']
        }
      },
      {
        name: 'AudienceRollingSegmentDestinations',
        path: '/audiences/rolling-segment/destinations',
        component: RollingSegmentTabDestinations,
        project: true,
        meta: {
          auth: ['viewProjectItem']
        }
      }
    ]
  },
  {
    name: 'AudienceSharedSegment',
    path: '/audiences/shared-segment/evaluations',
    component: SharedSegmentPage,
    meta: {
      auth: ['viewProjectItem'],
      title: 'Audiences_Title'
    },
    children: [
      {
        name: 'AudienceSharedSegmentEvaluations',
        path: '/audiences/shared-segment/evaluations',
        component: SharedSegmentTabEvaluations,
        project: true,
        meta: {
          auth: ['viewProjectItem']
        }
      }
    ]
  },
  {
    name: 'AudienceSegmentCreate',
    path: '/audiences/segment/create',
    component: SegmentPageCreate,
    meta: {
      auth: ['Segment::Create'],
      title: 'Audiences_Title'
    }
  },
  {
    name: 'AudienceSegmentUpdate',
    path: '/audiences/segment/update',
    component: SegmentPageUpdate,
    meta: {
      auth: ['Segment::Update'],
      title: 'Audiences_Title'
    }
  },
  {
    name: 'AudienceSegmentCopy',
    path: '/audiences/segment/copy',
    component: SegmentPageCopy,
    meta: {
      auth: ['Segment::Update'],
      title: 'Audiences_Title'
    }
  },
  {
    name: 'AudienceRollingSegmentCreate',
    path: '/audiences/rolling-segment/create',
    component: RollingSegmentPageCreate,
    meta: {
      auth: ['createProjectItem'],
      title: 'Audiences_Title'
    }
  },
  {
    name: 'AudienceRollingSegmentUpdate',
    path: '/audiences/rolling-segment/update',
    component: RollingSegmentPageUpdate,
    meta: {
      auth: ['updateProjectItem'],
      title: 'Audiences_Title'
    }
  },
  {
    name: 'AudienceRollingSegmentCopy',
    path: '/audiences/rolling-segment/copy',
    component: RollingSegmentPageCopy,
    meta: {
      auth: ['updateProjectItem'],
      title: 'Audiences_Title'
    }
  }
]



// WEBPACK FOOTER //
// ./src/modules/audiences/router/index.js